import React, {Component} from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import {
    Link
  } from "react-router-dom";
  import ReactGA from 'react-ga'
  import Badge from 'react-bootstrap/Badge'
  import MetaTags from 'react-meta-tags';

class LlistaMunicipis extends Component {
 

    retornaEscrutat(valor) {
        if (valor===0) return "secondary";
        if (valor<50) return "danger";
        if (valor>=50&&valor<85) return "warning";
        if (valor>=85) return "success";
    }

    generaDadesMunicipi(municipi) {

        var resultat;
         this.props.resultats.forEach(element => {
            if (element.dadesMunicipi.codi == municipi.codi_generalitat) resultat=element;
        });
        // console.log(resultat);


        return (<div className="itemMunicipi itemLlista" key={"municipi_"+municipi.slug}>
             <Link to={"/resultats/" + municipi.slug}>
                 <div className="nomMunicipiLlista">{municipi.nom}</div>
                 <div className="dadesAddicionalsLlista">
                    {resultat && <div className="escrutatLlista"><Badge variant={this.retornaEscrutat(resultat.dadesElectorals.censEscrutat_per)}>{resultat.dadesElectorals.censEscrutat_per.toString().replace(/\./g, ',')}% escrutat</Badge></div>}



                    {resultat&&resultat.resultatsCandidatures.length!=0 && <div className="primerLlocLlista">Més votat: {this.escriuNomPartit(resultat.resultatsCandidatures[0])} ({resultat.resultatsCandidatures[0].vots_per.toString().replace(/\./g, ',')}%)</div>}
                </div>
            </Link>
         </div>)

    }

    escriuNomPartit(candidatura) {
        //Busquem si la candidatura està a la BD de partits
        var sigles = candidatura.sigles;
        var nomPartit;
        var color = "#FFFFFF";

        this.props.partits.forEach(element => {
            if (element.codi_generalitat === candidatura.codi)  {
                sigles = element.sigles;
                nomPartit = element.nom;
                color = element.color;
            }
        });

        return (
            <span><span className="quadrat colorCandidatura" style={{backgroundColor: color}}></span> {sigles}</span>
        )
    }

    generaLlista() {
        
        return this.props.municipis.map((municipi)=>
        this.generaDadesMunicipi(municipi)
         )
    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname) //Afegir a cada pàgina que cal comptar
    }

    render() {   
        return (


            <div className="llista_municipis">
                <MetaTags>
                        <title>Resultats eleccions al Parlament de Catalunya 2021 als municipis del Berguedà - Aquí Berguedà</title>
                        <meta name="description" content={"Consulta tots els resultats a les eleccions al Parlament de Catalunya 2021"} />
                        <meta property="og:title" content={"Resultats eleccions al Parlament de Catalunya 2021 als municipis del Berguedà"} />
                </MetaTags>         
                            
                <Breadcrumb>
                    <Breadcrumb.Item active>Municipis</Breadcrumb.Item>
                </Breadcrumb>

                <h5>Escull el municipi del que vulguis saber el resultat</h5>
                {this.props.municipis&&this.props.resultats && this.generaLlista()}
            </div>
        );
    }
}

export default LlistaMunicipis; 